var $ = global.jQuery = global.$;
var _Base = require('./_Base');
var FilterItem = require('./FilterItem_PTS');
var filterTemplate = require('../templates/course.dot');
var _debounce = require('lodash/function/debounce');
var _extend = require('lodash/object/extend');
var widgets = require('../lib/widgets');
require('html5-history-api');

var CourseFilter = _Base.extend({
  init: function() {
    var self = this;
    this.debouncedGetItems = _debounce(this.getItems, 300);
    this.initialCriteria = this.$el.data('criteria') || {};
    this.action = this.$el.prop('action');
    this.criteria = {};
    this.filters = {};
    this.page = 1;
    this.$loader = this.$el.find('[data-load]');
    this.$keyword = this.$el.find('[data-keyword]');
    this.serializedFormFields = this.$el.serialize();
    this.$reset = this.$el.find('[data-clear-all]');
    this.$filters = this.$el.find('[data-filter]');
    this.$itemArea = this.$el.find('[data-filter-items]');
    this.$desktopFilters = this.$el.find('[data-desktop-filters]');
    this.$resultsText = this.$el.find('[data-results]');
    this.$reset.on('click', this.reset.bind(this));
    this.$el.on('Filter:Updated', this.onFilterUpdated.bind(this));
    this.$el.on('Filter:Open', this.openFilter.bind(this));
    this.$el.on('Close:Siblings', this.closeSiblings.bind(this));
    this.$el.on('Close:Children', this.closeChildren.bind(this));
    this.$el.on('Open:Children', this.openChildren.bind(this));
    this.$el.on('Clear:Siblings', this.clearSiblings.bind(this));
    this.$el.on('Clear:Children', this.clearChildren.bind(this));
    this.$el.on('Paging:clickTriggered', this.onPagingClick.bind(this));
    this.createFilterItems();
    this.setCriteria(this.initialCriteria);

  },
  onWidgetsReady: function() {
    this.itemArea = widgets.getWidget('itemArea');
    this.pagination = widgets.getDescendants(this.$el, 'Pagination')[0];
  },
  /**
   * Handle paging clicks
   * @param {object} event
   * @param {number} page The new page number
   * @private
   */
  onPagingClick: function(event, page) {
    if (page !== this.page) {
      this.debouncedGetItems(page);
    }
  },
  onFilterUpdated: function(event, name, value, children) {
    this.criteria[name] = value;
    if (value !== -1) delete this.initialCriteria.Keyword;
    // if (this.checkFiltersEmpty() && !this.criteria.Keyword ) {
    //   this.$reset.addClass('is-open');
    // } else {
    //   this.$reset.removeClass('is-open');
    // }
    this.debouncedGetItems(1);
    if (children.length || value === -1) {
      this.setCount(name, 0);
    } else if (value.length && Array.isArray(value)) {
      this.setCount(name, value.length);
    }
  },
  openFilter: function(event, name) {
    if (this.filters[name]) this.filters[name].open();
  },
  checkReset: function () {
    if (this.checkFiltersEmpty() && !this.getCriteria().Keyword ) {
      this.$reset.addClass('is-open');
    } else {
      this.$reset.removeClass('is-open');
    }
  },
  setQueryString: function() {
    var filledCriteria = {};
    var criteria = this.getCriteria();
    for (var item in criteria) {
      if (criteria.hasOwnProperty(item)) {
        if (criteria[item] !== -1 && item !== 'Page') filledCriteria[item] = criteria[item];
      }
    }
    var param = $.param(filledCriteria);

    if (param.length === 0) {
      var location = window.history.location || window.location;
      var uri = location.toString();
      if (uri.indexOf('?') > 0) {
        var cleanUri = uri.substring(0, uri.indexOf('?'));
        history.replaceState({}, document.title, cleanUri);
      }
    } else {
      history.replaceState(null, null, '?' + param);
    }
  },
  checkFiltersEmpty: function() {
    for (var filter in this.filters) {
      if (this.filters.hasOwnProperty(filter)) {
        if (this.filters[filter].value !== -1) return false;
      }
    }
    return true;
  },
  getChildLength: function(items) {
    var length = 0;
    items.forEach(function(item) {
      var val = this.filters[item].value;
      if (Array.isArray(val)) length += val.length;
    }.bind(this));
    return length;
  },
  setCount: function(name, count) {
    this.filters[name].setCount(count);
  },
  reset: function() {
    event.preventDefault();
    delete this.initialCriteria.Keyword;
    for (var item in this.filters) {
      if (this.filters.hasOwnProperty(item)) {
        this.filters[item].clear();
        this.filters[item].close();
      }
    }
  },
  createFilterItems: function() {
    var self = this;
    this.$filters.each(function(index) {
      var filter = $(this).data('filter');
      self.filters[filter] = new FilterItem(this);
      self.$desktopFilters.append(self.filters[filter].$contentClone);
    });
    this.$desktopFilters.find('[data-filter]').each(function(){
      var filter = self.filters[$(this).data('filter')];
      filter.$el = filter.$el.add($(this));
      filter.$toggle = filter.$toggle.add($(this).find('[data-sh-toggle]'));
      filter.bindToggleEvents($(this).find('[data-sh-toggle]'));
    });
  },
  setCriteria: function(criteria) {
    for (var item in this.filters) {
      if (this.filters.hasOwnProperty(item)) {
        var filter = this.filters[item];
        var newValue = criteria[filter.filter] || -1;
        filter.setValue(newValue);
        if (newValue !== -1) {
          filter.open();
        }
      }
    }
  },
  closeSiblings: function(event, siblings) {
    siblings.forEach(function(sibling) {
      if (this.filters[sibling]) this.filters[sibling].close();
    }.bind(this));
    this.$reset.removeClass('is-open');
  },
  closeChildren: function(event, children) {
    children.forEach(function(child) {
      if (this.filters[child]) this.filters[child].close();
    }.bind(this));

  },
  openChildren: function(event, children) {
    children.forEach(function(child) {
      var value = this.filters[child].value;
      if (value.length && Array.isArray(value)) {
        this.filters[child].open();
        this.filters[child].setCount(value.length);
      }
    }.bind(this));
  },
  clearSiblings: function(event, siblings) {
    siblings.forEach(function(sibling) {
      if (this.filters[sibling]) this.filters[sibling].clear();
    }.bind(this));
  },
  clearChildren: function(event, children) {
    children.forEach(function(child) {
      if (this.filters[child]) this.filters[child].clear();
    }.bind(this));
  },
  getCriteria: function() {
    return _extend(this.initialCriteria, this.criteria);
  },
  /**
   * Make a new request to the query URL
   * @returns {object} Returns the ajax request object
   */
  getItems: function(page) {
    if (!this.$itemArea.length) return false;
    var self = this;
    var prevHeight = this.$itemArea.height();
    this.$itemArea
      .height(prevHeight)
      .empty();

    this.$loader.velocity('fadeIn');

    data = this.getCriteria();
    data.Page = page;

    var req = $.ajax({
        type: 'GET',
        contentType: 'application/json',
        url: this.action + '?' + this.serializedFormFields,
        data: data
      })
      .done(this._getItemsSuccessHandler.bind(this))
      .fail(this._getItemsFailHandler.bind(this));

    return req;
  },
  /**
   * Handle a successful AJAX call response for the get items method
   * @param {object} response The JSON response containing the response
   * @param {number} queryNo Which query number this is. Used to determine whether to output the response from this query or not (in case multiple fields have been changed in quick succession)
   * @param {number} fieldIndex The index of the field that changed. Passed to the updateFilters method so that only filters after that index get updated.
   * @param {object} params The various parameters that have been passed to the getItems query
   * @param {object} fieldData The fields that have been passed to the query
   * @private
   */
  _getItemsSuccessHandler: function(response) {
    var self = this;
    if (response.Error && response.Error !== '') {
      self.showMessage(response.Error);
      self.pagination.totalPages = 1;
      self.pagination.goToPage(1, false);
      self.page = 1;
    } else {
      self.setQueryString();
      self.updateSearchText();
      self.updateItems(response.Value.Items, false);
      self.updateResultNumbers(response.Value.Shown);
      if (self.pagination) {
        self.pagination.totalPages = response.Value.Items.length === 0 ? 1 : response.Value.TotalPages;
        self.pagination.goToPage(response.Value.Items.length === 0 ? 1 : response.Value.Page, false);
      }
      self.page = response.Value.Items.length === 0 ? 1 : response.Value.Page;
      self.checkReset();

    }
  },
  updateSearchText: function(shown) {
    var keyword = this.getCriteria().Keyword;
    if (keyword && keyword !== -1) {
      this.$keyword.html(' matching keyword <strong>"' + keyword + '"</strong>');
    } else {
      this.$keyword.html('');
    }
  },
  updateResultNumbers: function(shown) {
    this.$resultsText.text(shown);
  },
  /**
   * Handle a failed AJAX call response for the get items method
   * @private
   */
  _getItemsFailHandler: function() {
    var self = this;
    self.showMessage('The server couldn\'t be reached right now, please try again later');
    self.pagination.totalPages = 1;
    self.pagination.goToPage(1, false);
    self.page = 1;
  },
  /**
   * Empty the item area
   */
  emptyItems: function() {
    var self = this;
    this.$itemArea.empty();

  },
  /**
   * Update the displayed items
   * @param {array} items The array of new items to add to the item area
   * @param {bool} append Whether or not to append the new items. If false/null will
   */
  updateItems: function(items, append) {
    var self = this;

    this.$loader.velocity('fadeOut');

    if (!append) {
      this.emptyItems();
    }

    if (items.length === 0) {
      this.emptyItems();
      this.showMessage('No results for those criteria, please try again');
    }

    $.each(items, function(index) {
      var that = this;
      setTimeout(function() {
        that.itemIndex = index;
        self.$itemArea.append(self.renderItem(that));
      }, index * 100);
    });

    if (this.itemArea) {
      setTimeout(function() {
        self.itemArea.getTargets();
        self.itemArea.equalise();
        self.$itemArea.height('auto');
        var scrollTop = $(window).scrollTop();
        var resultsScrollTop = self.$resultsText.offset().top;
        if (resultsScrollTop < scrollTop) $(window).scrollTop(resultsScrollTop);
      }, items.length * 100);
    }


  },
  /**
   * Render an item using the item template
   * @param {object} item The item to pass through the template
   */
  renderItem: function(item) {
    return filterTemplate(item);
  },
  /**
   * Show a message in the filter area
   * @param {string} message The message to show
   */
  showMessage: function(message) {
    this.$itemArea.html('<p class="filter-message">' + message + '</p>');
  },
});

module.exports = CourseFilter;



//////////////////
// WEBPACK FOOTER
// ./source/scripts/widgets/CourseFilter_PTS.js
// module id = 283
// module chunks = 1